import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
import { useAppSelector } from 'utils/redux/useAppSelector';
import styles from './conversationPreviewActions.module.scss';
export const ConversationPreviewActions = ({ onGoToConversation, onClose, agent, }) => {
    const latestMessageSentNotifications = useAppSelector((state) => state.notifications.currentNotifications.filter(({ type }) => type === 'messageSent'));
    useCommandHandler({
        name: 'conversation:goToConversation',
        actionFn: () => {
            if (latestMessageSentNotifications.length) {
                return;
            }
            onGoToConversation();
        },
    });
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx("div", Object.assign({ className: styles.avatar }, { children: _jsx(Avatar, { user: agent }) })), _jsx(Tooltip, Object.assign({ dark: true, content: _jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:goToConversation" }, { children: "View conversation" })) }, { children: _jsx(Button, Object.assign({ onClick: onGoToConversation, variant: "secondary" }, { children: "Go to conversation" })) })), _jsx(IconButton, { onClick: onClose, icon: "close", variant: "secondary" })] })));
};
